import type { IconButtonProps } from '../IconButton'
import type { Tokens } from '../../../theming/types'

export default (config: {
  props: Pick<IconButtonProps, 'kind' | 'size'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  const iconButtonStyles = {
    brand: {
      color: tokens.button.main.defaultTextColor,
    },
    primary: {
      color: tokens.button.primary.defaultTextColor,
    },
    secondary: {
      color: tokens.iconColorDefault,
    },
    tertiary: {
      backgroundColor: tokens.button.tertiary.defaultBackgroundColor,
      color: tokens.iconColorDefault,
    },
    danger: {
      backgroundColor: tokens.button.danger.defaultBackgroundColor,
      color: tokens.button.danger.defaultTextColor,
    },
  }

  return {
    button: {
      default: {
        ...iconButtonStyles[props.kind!],

        '& svg': {
          fill:
            props.kind === 'tertiary' || props.kind === 'secondary'
              ? tokens.iconColorDefault
              : 'currentColor',
        },
      },
    },
  } as const
}
